import type { CreatorProfileData } from '@adthlete/common'
import type { PublicTalentSheet } from '@adthlete/shared-frontend'
import { marketerApi } from './marketerApi'

// Talent sheets a manager shared with brands. These endpoints are public: brands can view a
// sheet before they have an account.

export interface PublicSheetAthlete {
  athlete: CreatorProfileData
  sheet: { title: string; brandName: string | null }
  /** Their Content Shop: what the brand can book from them */
  shop?: import('@adthlete/shared-frontend').MarketplaceProfileData
}

export const talentSheetsApi = marketerApi.injectEndpoints({
  endpoints: (builder) => ({
    getPublicTalentSheet: builder.query<PublicTalentSheet, string>({
      query: (hashedId) => `/public/talent-sheets/${hashedId}`,
      transformResponse: (r: { sheet: PublicTalentSheet }) => r.sheet,
    }),
    getPublicSheetAthlete: builder.query<
      PublicSheetAthlete,
      { sheetId: string; athleteId: string }
    >({
      query: ({ sheetId, athleteId }) => `/public/talent-sheets/${sheetId}/athletes/${athleteId}`,
    }),
    recordTalentSheetView: builder.mutation<void, { sheetId: string; visitorId: string }>({
      query: ({ sheetId, visitorId }) => ({
        url: `/public/talent-sheets/${sheetId}/views`,
        method: 'POST',
        body: { visitorId },
      }),
    }),
  }),
})

export const {
  useGetPublicTalentSheetQuery,
  useGetPublicSheetAthleteQuery,
  useRecordTalentSheetViewMutation,
} = talentSheetsApi
